import { ShadowContainer } from '../../common/ShadowContainer';
import { Avatar, Box, Checkbox, FormControlLabel, FormGroup, MenuItem, TextField, Typography } from '@mui/material';
import { TEXTS } from '../../../core/texts';
import { ColumnBoxFlexFullWidth, ColumnFlexBox, FlexBoxFullWidth } from '../../common/boxes';
import React, { useCallback, useContext, useState } from 'react';
import { ClientContext } from './ClientEntity';
import { CustomerStatus } from '../../../enums/customerStatus';
import { useTheme } from '@mui/material/styles';
import { ValidationErrorState } from '../../../types/validationErrorState';
import { ICustomerFullProfile } from '../../../interfaces/customer';
import { IClientAdminSearch } from '../../../interfaces/clientAdminSearch';

const ClientPersonalInfo = () => {
  //TODO implement editing mode when api extended
  const theme = useTheme();
  const [editMode] = useState(false);
  const [validationErrors] = useState<ValidationErrorState>({});
  const { user } = useContext(ClientContext);
  const [state] = useState<IClientAdminSearch>({...getEditablePropsFromUser(user), id: user.id});
  
  const handleInputChange = useCallback(() => {},[]);

  return (
    <ShadowContainer>
      <FlexBoxFullWidth justifyContent={'space-between'} mb={3}>
        <Typography variant={'h3'} sx={{ mb: 3, textAlign: 'center' }}>
          {TEXTS.PERSONAL_INFORMATION}
        </Typography>

      </FlexBoxFullWidth>

      <ColumnBoxFlexFullWidth position={'relative'}>
        <Box mr={{ mobile: 0, laptop: 4 }} mb={2}>
          <Avatar sx={{
            border: `1px solid ${theme.palette.primary.dark}`,
            width: { mobile: 60, tablet: 100 },
            height: { mobile: 60, tablet: 100 },
            fontSize: { mobile: 22, tablet: 40 },
            mr: { mobile: 0, tablet: 4 }
          }}>
            {user.clientProfile.legalName.slice(0,2)}
          </Avatar>
        </Box>

        <ColumnFlexBox justifyContent={'center'} width={'100%'} maxWidth={500}>
          <TextField name={'id'} label={TEXTS.ID} variant={'standard'}
                     value={state.id} disabled={true} sx={{ mt: 2 }}
          />
          <TextField name={'legalName'} label={TEXTS.LEGAL_NAME} variant={editMode ? 'outlined' : 'standard'}
                     error={!!validationErrors.legalName}
                     helperText={validationErrors.legalName} value={state.legalName} disabled={!editMode} sx={{ mt: 2 }}
                     onChange={handleInputChange}
          />
          <TextField name={'contactName'} label={TEXTS.CONTACT_NAME} variant={editMode ? 'outlined' : 'standard'}
                     error={!!validationErrors.contactName}
                     helperText={validationErrors.contactName} value={state.contactName} disabled={!editMode} sx={{ mt: 2 }}
                     onChange={handleInputChange}
          />
          <TextField name={'email'} label={TEXTS.EMAIL} variant={editMode ? 'outlined' : 'standard'}
                     error={!!validationErrors.email}
                     helperText={validationErrors.email} value={state.email} disabled={!editMode} sx={{ mt: 2 }}
                     onChange={handleInputChange}
          />
          <TextField name={'phone'} label={TEXTS.PHONE} variant={editMode ? 'outlined' : 'standard'}
                     error={!!validationErrors.phone}
                     helperText={validationErrors.phone} value={state.phone} disabled={!editMode} sx={{ mt: 2 }}
                     onChange={handleInputChange}
          />
          <TextField name={'status'} label={TEXTS.STATUS} value={state.status} disabled={!editMode} sx={{ mt: 2 }}
                     error={!!validationErrors.status} helperText={validationErrors.status} onChange={handleInputChange}
                     select variant={editMode ? 'outlined' : 'standard'}
          >
            {
              Object.values(CustomerStatus).map(status => (
                <MenuItem key={status} value={status}>{status}</MenuItem>
              ))
            }
          </TextField>
          <TextField name={'projectDescription'} label={TEXTS.DESCRIPTION} variant={editMode ? 'outlined' : 'standard'}
                     error={!!validationErrors.projectDescription}
                     helperText={validationErrors.projectDescription} value={state.projectDescription} disabled={!editMode} sx={{ mt: 2 }}
                     onChange={handleInputChange}
          />

          <FormGroup sx={{ mt: 2 }}>
            <FormControlLabel control={<Checkbox checked={state.emailVerified}/>} disabled={!editMode}
                              name={'emailVerified'} label={'Email Verified'}/>
          </FormGroup>
        </ColumnFlexBox>

      </ColumnBoxFlexFullWidth>

    </ShadowContainer>
  );
};

export function getEditablePropsFromUser(user: ICustomerFullProfile): IClientAdminSearch {
  const {
    clientProfile: {
      legalName,
      contactName,
      projectDescription,
    }, email, emailVerified, status, phone,
  } = user;
  return {
    legalName,
    contactName,
    projectDescription,
    email,
    emailVerified,
    status,
    phone
  } as IClientAdminSearch;
}

export default ClientPersonalInfo;